import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import Invoice from '@/views/Invoice.vue'
import DeeplinkLoop from "@/views/DeeplinkLoop.vue";
import AlfaCardPreview from "@/views/AlfaCardPreview.vue";
import KazakhstanCardPreview from "@/views/KazakhstanCardPreview.vue";

const routes: Array<RouteRecordRaw> = [
    {path: '/invoice', name: 'invoice', component: Invoice},
    {path: '/dl', name: 'dl', component: DeeplinkLoop},
    {path: '/preview/alfa-card', name: 'alfa-card-preview', component: AlfaCardPreview},
    {path: '/preview/kazakhstan', name: 'kazakhstan-preview', component: KazakhstanCardPreview},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router

